import React, { Component } from 'react';
import App_data from '../../config/App_data';
import FD from '../../RestAPI/fetchData';
import language from '../../../assets/languages/language';
import AppRoutes from '../../config/AppRoutes';
import { messages } from '../../../common/messages';
import QuestionModeSetting from '../../../Components-2025/QuestionModeSetting';
import { EXAM_NAMES } from '../../../common/constant';

/* eslint-disable*/
class Cfa2_2023QuestionBank extends Component {
  constructor(props) {
    super(props);
    this.state = {
      alert_status: false,
      MessageTitle: `${language.LC().ALERT}`,
      MessageContent: `${language.LC().ERROR}`,
      chapters: [],
      token: '',
      freeChapterCount: [],
      idname: '',
      ValidToken: false,
      chapter_id: '',
      offset: 0,
      limit: 10,
      lastRecord: '',
      lastAttempt: false,
    };
    this.toggleAlert = this.toggleAlert.bind(this);
    //this._getReadings = this._getReadings.bind(this);
  }

  static contextTypes = {
    router: React.PropTypes.object,
  };

  toggleAlert() {
    this.setState({
      alert_status: !this.state.alert_status,
    });
  }

  _getCases = (chapter, e) => {
    // console.log('chapter--------------------', chapter);
    this.context.router.push({
      pathname: AppRoutes.CFA2_2025_QUESTION_BANK_CASES.replace(':id', chapter.id)
        .replace(':chapter_name', chapter.chapter_name)
        .replace(':total_cases', chapter.total_cases),
      // `/cfa2_cases/${chapter.id}/${chapter.chapter_name}/${
      //   chapter.total_cases
      // }`,
      // state: {
      //   token: this.state.token,
      //   idname: this.state.idname,
      //   chapter: chapter,
      // },
    });
  };

  componentDidMount() {
    window.scroll(0, 0);
    var storage_session = JSON.parse(localStorage.getItem('localstorageval'));
    this.setState({ idname: storage_session['idname'] });
    this.setState({ token: storage_session['token'] });
    var data = {
      token: storage_session['token'],
      idname: storage_session['idname'],
    };
    FD.callAPI(App_data.backend_api + '/cfa_2_2025question_bank/getChapters', data).then(
      async (resp) => {
        if (resp.success) {
          this.setState({
            ValidToken: true,
            chapters: resp.chapters,
            freeChapterCount: resp.freeChapterCount,
          });
          await FD.callAPI(
            App_data.backend_api + '/cfa_2_2025question_bank/getlastAnsweredQuestion',
            data,
          ).then((response) => {
            if (response.success) {
              this.setState({
                lastRecord: response.data,
                lastAttempt: true,
              });
            }
          });
        } else {
          this.setState({ ValidToken: false });
        }
        return resp;
      },
    );
  }

  goToQuestion = () => {
    const { lastRecord, lastAttempt } = this.state;
    if (lastAttempt) {
      this.context.router.push({
        pathname: AppRoutes.CFA2_2025_QUESTION_BANK_CASES_QUESTION.replace(
          ':chapterid',
          lastRecord.cfa2_question.chapter_id_2025,
        )
          .replace(':caseid', lastRecord.cfa2_question.case_id)
          .replace(':case_offset', lastRecord.caseIndex)
          .replace(':question_number', lastRecord.cfa2_question.question_number)
          .replace(':offset', 0),
      });
    }
  };
  render() {
    let chapters = this.state.chapters;
    let countFree = this.state.freeChapterCount;
    const { lastAttempt } = this.state;
    let data = '';
    let percent_data = [
      '5-10%', //Quanititive
      '5-10%', //Economics
      '10-15%', //Financial reporting
      '5-10%', //Corporate
      '10-15%', //Equity
      '10-15%', //Fixed income
      '5-10%', //Derivative
      '5-10%', //Alternative
      '10-15%', //Portfolio
      '10-15%', //Ethics
    ];

    if (this.state.chapters.length && this.state.freeChapterCount.length) {
      let count = 0;
      data = chapters.map((item, index) => {
        const itemFree = this.state.freeChapterCount.find((obj) =>
          obj.id === item.id ? (count = obj.count) : (count = 0),
        );

        return (
          <div
            className='col-md-6 col-lg-6 col-xl-4 question_box free-premium-section'
            key={index}
            onClick={this._getCases.bind(this, item)}
          >
            <div className='question_bank_wrap pointer_class' key={item.id}>
              <div className='margin_bottom_30'>
                <img
                  src={App_data.frontend_url + '/img/question_bank/icon2.svg'}
                  width='54'
                  className=''
                  alt=''
                />
              </div>

              <div className='question_title' key={item.id} value={item.id}>
                <a
                  className='pointer_class'
                  id={item.chapter_name}
                  value={item.chapter_no}
                  onClick={this._getCases.bind(this, item)}
                >
                  {item.id}. {item.chapter_name}
                </a>
              </div>

              <ul key={item.chapter_name}>
                <li>
                  <span>
                    <img
                      src={App_data.frontend_url + '/img/question_bank/free_reading_icon.svg'}
                      className=''
                      width='25'
                      alt=''
                    />
                  </span>
                  <span>{percent_data[index]}</span>
                </li>
                <li>
                  <span>
                    <img
                      src={App_data.frontend_url + '/img/question_bank/free_question_icon.svg'}
                      className=''
                      width='26'
                      alt=''
                    />
                  </span>
                  <span>{count}</span>
                  <div className='tootip_box'> {language.LC().FREE_CASES} </div>
                </li>
                <li>
                  <span>
                    <img
                      src={App_data.frontend_url + '/img/question_bank/premium_question_icon.svg'}
                      className=''
                      width='23'
                      alt=''
                    />
                  </span>
                  <span>{item.total_cases}</span>
                  <div className='tootip_box'> {language.LC().PREMIUM_CASES} </div>
                </li>
              </ul>
            </div>
          </div>
        );
      });
    } else {
      data = (
        <div className='loader_box'>
          <div className='sk-circle'>
            <div className='sk-circle1 sk-child' />
            <div className='sk-circle2 sk-child' />
            <div className='sk-circle3 sk-child' />
            <div className='sk-circle4 sk-child' />
            <div className='sk-circle5 sk-child' />
            <div className='sk-circle6 sk-child' />
            <div className='sk-circle7 sk-child' />
            <div className='sk-circle8 sk-child' />
            <div className='sk-circle9 sk-child' />
            <div className='sk-circle10 sk-child' />
            <div className='sk-circle11 sk-child' />
            <div className='sk-circle12 sk-child' />
          </div>
        </div>
      );
    }
    return (
      <div className='animated fadeIn'>
        <div className='margin_bottom_20 d-flex justify-content-between last_question_read'>
          <h1 className='section_head'>{language.LC().CFA_LEVEL_II_QUESTION_BANK}</h1>
          <QuestionModeSetting examNameKey={EXAM_NAMES.CFA_2} />
          {lastAttempt && (
            <button
              className='btn btn-primary pointer_class'
              onClick={this.goToQuestion}
              disabled={!lastAttempt}
            >
              {messages.GO_TO_MY_LAST_QUESTION_ANSWERED}
            </button>
          )}
        </div>
        <div className='row'>
          <div className='col-sm-12 col-md-12 seperator-block-wrap'>
            <div className='card'>
              <div className='card-block'>
                <div className='card-block'>
                  <div className='row'>{data}</div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default Cfa2_2023QuestionBank;



// WEBPACK FOOTER //
// ./src/views/CFA2-2025/QuestionBank/Cfa2_2023QuestionBank.js